import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import { actions as ruleinstanceactions } from "../../../components/ReportComponents/RuleInstanceSearch/redux";
import { ArrowDropDown, ArrowDropUp, KeyboardArrowLeft, KeyboardArrowRight, CloudDownload } from "@material-ui/icons";
import {
	Button,
	Card,
	CardContent,
	Grid,
	Select,
	MenuItem,
	TextField,
	Paper,
	Divider,
	ClickAwayListener,
	CircularProgress
} from "@material-ui/core";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import MaterialAutoSuggest from "../../../components/AutoSuggest/MaterialAutoSuggest/MaterialAutoSuggest";
import RuleInstanceSearch from "../../../components/ReportComponents/RuleInstanceSearch/RuleInstanceSearch";
import CSSModules from "react-css-modules";
import { DateTime, pointName, string, array, secondsToTimePeriod } from "../../../utils";
import { DateRangePicker } from "../../../libs/react-date-range";
import { Interval, Point, PointDisplay } from "../../../services/Live/types";
import PercentageOutsideRangeChart from "../../../components/ReportComponents/Charts/PercentageOutsideRangeChart/PercentageOutsideRangeChart";
import ValidationRuleChart from "../../../components/ReportComponents/Charts/ValidationRuleChart/ValidationRuleChart";
import ValidationWithBarChart from "../../../components/ReportComponents/Charts/ValidationWithBarChart/ValidationWithBarChart";
import ValidationRuleOutsideOffsetChart from "../../../components/ReportComponents/Charts/ValidationRuleOutsideOffsetChart/ValidationRuleOutsideOffsetChart";
import ValidationWithBarOutsideOffsetChart from "../../../components/ReportComponents/Charts/ValidationWithBarOutsideOffsetChart/ValidationWithBarOutsideOffsetChart";
import OccurrencesTable from "../../../components/ReportComponents/Tables/OccurrencesTable/OccurrencesTable";
import HourlyFailureHeatMap from "../../../components/ReportComponents/HeatMaps/HourlyFailureHeatMap/HourlyFailureHeatMap";
import DailyFailureHeatMap from "../../../components/ReportComponents/HeatMaps/DailyFailureHeatMap/DailyFailureHeatMap";
import TimeOutsideRangeChart from "../../../components/ReportComponents/Charts/TimeOutsideRangeChart/TimeOutsideRangeChart";
import SampleSummaryTable from "../../../components/ReportComponents/Tables/SampleSummaryTable/SampleSummaryTable";
import DailyFailureChart from "../../../components/ReportComponents/Charts/DailyFailureChart/DailyFailureChart";
import LineChart from "../../../components/ReportComponents/Charts/LineChart/LineChart";
import ReportLiveLineChart from "../../../components/ReportComponents/Charts/ReportLiveLineChart/ReportLiveLineChart";
import HistoryTable from "../../../components/ReportComponents/Tables/HistoryTable/HistoryTable";
import ColumnChart from "../../../components/ReportComponents/Charts/ColumnChart/ColumnChart";
import BarChart from "../../../components/ReportComponents/Charts/BarChart/BarChart";
import LearnedRuleTable from "../../../components/ReportComponents/Tables/LearnedRuleTable/LearnedRuleTable";
import ScatterChart from "../../../components/ReportComponents/Charts/ScatterChart/ScatterChart";
import SmartTable from "../../../components/SmartTable/SmartTable";
import { actions as headeractions } from "../../../components/Header/redux";
import HtmlParser from "react-html-parser";
import DiagnosticOutput from "../../../components/ReportComponents/Tables/DiagnosticOutput/DiagnosticOutput";
import ChartTooltip from "../../../components/ReportComponents/Charts/ChartTooltip/ChartTooltip";
import moment from 'moment-timezone';
import ChartCommentModals from "../../../components/ChartComment/ChartCommentModals";
import { actions as timeaction } from "../../../redux/timeRedux";

import pdficon from "../../../assets/Icons/pdf.png";
import informationicon from "../../../assets/Icons/information.png";
import Tooltip, { TooltipContent } from '../../../components/Tooltip/tooltip';
import { ReportUrl } from '../../../services/reportUrl';

const getSuggestionValue = suggestion => suggestion.name;

@CSSModules(styles, { allowMultiple: true })
class Rules extends Component {
	constructor(props) {
		super(props);

		if (props.match.params.dateRange) {
			let fromDate = moment(props.match.params.dateRange.split(',')[0]);
            let toDate = moment(props.match.params.dateRange.split(',')[1]);
            if (
                toDate.isValid() && 
                fromDate.isValid() &&
                fromDate <= toDate
            ) {
                this.changeTime({
                    selection: {
                        startDate: fromDate.startOf('day').toDate(),
                        endDate: toDate.endOf('day').toDate(),
                        key: "selection"
                    }
                });
            }
        } 
        else
            ReportUrl.updateReportUrlWithDate(props.time.startDate, props.time.endDate);
        

		let hasList =
			props.match.params.list !== undefined &&
			props.match.params.list.length > 0 &&
			props.match.params.index !== undefined;
		this.state = {
			list: hasList ? props.match.params.list.split(",") : undefined,
			index: hasList ? Number(props.match.params.index) : undefined,
			hasList: hasList
		};

	}

	componentWillMount() {
		this.props.toggleHeaderSelect(false);
		/*if (this.props.location && this.props.location.state && this.props.location.state.time) {
			this.props.changeTime({ selection: this.props.location.state.time });
		}*/
	}

	componentWillUnmount() {
        this.props.toggleHeaderSelect(true);
        this.props.resetState();
	}

	changeTime(result) {
		const range = result.selection || result.range1;
		range.endDate = DateTime.endOf("day", range.endDate);
		this.props.changeTime(range);
		  ReportUrl.updateReportUrlWithDate(range.startDate, range.endDate);
		  
		this.props.getCommentList(this.props.selectedRuleInstance.ruleInstanceId, range.startDate, range.endDate);
	}

	datepickerClickAway = () => {
		if (this.props.calendarOpen) {
			this.props.toggleCalendar();
		}
	};

	closeCalendar() {
		this.props.toggleCalendar();
	}

	sameDay(d1, d2) {
		return (
			d1 &&
			d2 &&
			d1.getFullYear() === d2.getFullYear() &&
			d1.getMonth() === d2.getMonth() &&
			d1.getDate() === d2.getDate()
		);
    }  
    

	exists(x) {
		return x !== undefined && x !== null && (x.length !== undefined && x.length !== null ? x.length > 0 : true);
	}

	getScheduleTimes(startTimes, endTimes) {
		let result = "<div>";
		for (var ii = 0; ii < startTimes.runAtTime.length; ii++) {
			result += "<div>" + startTimes.runAtTime[ii] + " - " + endTimes.runAtTime[ii] + "</div>";
		}
		result += "</div>";
		return result;
	}

	render() {
		const conf = this.props.report.ruleInstance.config;
		let cons = [];
		let dependantRules = [];
		let processVariables = [];
		let checks = [];
		let setPoint = null;
		if (conf) {
			cons = conf.conditions.preConditions;
			dependantRules = conf.conditions.ruleDepends;
			if (conf.fieldVars && conf.fieldVars.processVariables) {
				processVariables = conf.fieldVars.processVariables;
			}
			if(conf.fieldVars) {
				setPoint = conf.fieldVars.setPointId;
			}
			if (conf.fieldVars && conf.fieldVars.checks) {
				checks = conf.fieldVars.checks;
			}
		}
		return (
			<Grid container styleName="page-wrapper">
			{this.props.componentsLoaded &&
				<div style={{height: '0px', width: '0px'}} id="loadtracker">
			</div>	
			}
				{this.state.hasList === true &&
					this.state.index > 0 && (
						<div styleName="fixed-left" ismenuopen={this.props.isMenuOpen.toString()} title="Previous rule">
							<KeyboardArrowLeft
								onClick={() =>
									this.props.navigate(
										"/Reports/" +
											this.state.list[(this.state.index - 1)] +
											"/" +
											(this.state.index - 1) +
											"/" +
											this.state.list.map(rule => {
												return rule;
											}),
										{ time: this.props.time }
									)
								}
							/>
						</div>
					)}
				{this.state.hasList === true &&
					this.state.index < this.state.list.length - 1 && (
						<div styleName="fixed-right" title="Next rule">
							<KeyboardArrowRight
								onClick={() =>
									this.props.navigate(
										"/Reports/" +
											this.state.list[(this.state.index + 1)] +
											"/" +
											(this.state.index + 1) +
											"/" +
											this.state.list.map(rule => {
												return rule;
											}),
										{ time: this.props.time }
									)
								}
							/>
						</div>
					)}
				<Grid item xs={12} styleName="report-header">
					<Card styleName="report-card">
						<CardContent>
							<Grid container justify="space-between">
								<Grid item xs={6}>
									<RuleInstanceSearch />
								</Grid>
								<Grid item xs={6} style={{ textAlign: "right" }}>
									<Button onClick={() => this.props.toggleCalendar()} styleName="date-btn">
										{this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
											`${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`}
										{!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
											`${DateTime.formatToLocaleLongDate(
												this.props.time.startDate
											)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`}
										{this.props.calendarOpen && (
											<ArrowDropUp style={{ fill: "rgb(0, 0, 0, 0.54)" }} />
										)}
										{!this.props.calendarOpen && (
											<ArrowDropDown style={{ fill: "rgb(0, 0, 0, 0.54)" }} />
										)}
									</Button>
									<div styleName="calendar-wrap" isopen={this.props.calendarOpen.toString()}>
										<ClickAwayListener onClickAway={this.datepickerClickAway}>
											<div styleName="drpContainer">
												<DateRangePicker
													ranges={[this.props.time]}
													dragSelectionEnabled={false}
													showSelectionPreview={false}
													onChange={s => this.changeTime(s)}
												/>
												<div styleName="drpCloseButtonContainer">
													<div style={{ flex: 1 }} />
													<div
														styleName="drpCloseButton"
														onClick={() => this.closeCalendar()}
													>
														Close
													</div>
												</div>
											</div>
										</ClickAwayListener>
									</div>
								</Grid>
							</Grid>
							<Grid container styleName="report-info-title-container">
								<Grid item xs={12} md={3}>
									<div styleName="report-info-title">Description</div>
									<Divider light={true} />
									<div styleName="report-info-content">
										{this.props.selectedRuleInstance.description}
									</div>
								</Grid>
								<Grid item xs={false} md={1} />
								<Grid item xs={12} md={3}>
									<div styleName="report-info-title">Impact</div>
									<Divider light={true} />
									<pre styleName="report-info-content">{this.props.selectedRuleInstance.impact}</pre>
								</Grid>
								<Grid item xs={false} md={1} />
								<Grid item xs={12} md={3}>
									<div styleName="report-info-title">Possible Causes</div>
									<Divider light={true} />
									<pre styleName="report-info-content">
										{this.props.selectedRuleInstance.possibleCauses}
									</pre>
								</Grid>
							</Grid>
							<div styleName="align-right">
								{!this.props.pdfDownloadInProgress &&
									<Tooltip delay={50}>
										<div>
											<img src={pdficon} id="pdf-button" styleName="download-button" onClick={() => this.props.downloadPdf(this.props.match.params.ruleInstanceId)} />
										</div>
										<TooltipContent>
												<div style={{fontSize:12}}>
													Download as a PDF
												</div>
										</TooltipContent>
									</Tooltip>
								}
								{this.props.pdfDownloadInProgress && 
									<div styleName="spinner">
										<CircularProgress />
									</div>
								}
								<div styleName="infohover">
									&nbsp;
									<img src={informationicon} styleName="info-button" />
									<div styleName="infohover-tooltip">
										<div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Id:</div>
												<div>{this.props.report.ruleInstance.textId}</div>
											</div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Rule Type:</div>
												<div>{this.props.report.ruleInstance.rule !== null && this.props.report.ruleInstance.rule !== undefined ? this.props.report.ruleInstance.rule.description : ""}</div>
											</div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Report ID:</div>
												<div>{this.props.report.name}</div>
											</div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Enabled:</div>
												<div>
													{this.props.report.ruleInstance.enabled === true ? "Yes" : "No"}
												</div>
											</div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Running Now:</div>
												<div>
													{this.props.report.ruleInstance.isRunning === true ? "Yes" : "No"}
												</div>
											</div>
											{this.props.report.ruleInstance.nextRunTime && (
                                                <div styleName="info-pre-title">
                                                    <div styleName="info-pre-title-label">Next Run:</div>
                                                    <div>{this.getNextRunTime()}</div>
                                                </div>
                                            )}
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Rule Mode:</div>
												<div>
													{this.props.report.ruleInstance.isHistorical
														? "Historical"
														: "Live"}
												</div>
											</div>
											<div styleName="info-pre-title">
												<div styleName="info-pre-title-label">Reverse Mode:</div>
												<div>
													{this.props.report.ruleInstance.reverseMode == true
														? "Yes"
														: "No"}
												</div>
											</div>
											{conf !== undefined &&
												conf !== null &&
												conf.config !== undefined &&
												conf.config !== null && (
													<div>
														<div styleName="info-pre-title">
															<div styleName="info-pre-title-label">Sample Rate:</div>
															<div>{secondsToTimePeriod.convert(conf.config.testSampleRateSecs)}</div>
														</div>
														<div styleName="info-pre-title">
															<div styleName="info-pre-title-label">Settling Time:</div>
															<div>{secondsToTimePeriod.convert(conf.config.settlingTimeSecs)}</div>
														</div>
														{conf.config.failTimeOffsetSec > 0 && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Time Offset:</div>
																<div>{secondsToTimePeriod.convert(conf.config.failTimeOffsetSec)}</div>
															</div>
														)}
														{conf.config.upperLimDeviation && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Upper Limit/Deviation:</div>
																<div>{conf.config.upperLimDeviation}</div>
															</div>
														)}
														{conf.config.lowerLimDeviation && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Lower Limit/Deviation:</div>
																<div>{conf.config.lowerLimDeviation}</div>
															</div>
														)}
														{conf.config.percentageDeviation && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Percent Deviation:</div>
																<div>{conf.config.percentageDeviation * 100}%</div>
															</div>
														)}
														{conf.config.upperPercentageDeviation && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Increasing Deviation:</div>
																<div>{conf.config.upperPercentageDeviation * 100}%</div>
															</div>
														)}
														{conf.config.lowerPercentageDeviation && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Decreasing Deviation:</div>
																<div>{conf.config.lowerPercentageDeviation * 100}%</div>
															</div>
														)}
														{conf.config.period && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Period to Check:</div>
																<div>{conf.config.period}</div>
															</div>
														)}
														{conf.config.failCount && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Fail when Count Exceeds:</div>
																<div>{conf.config.failCount}</div>
															</div>
														)}
														{conf.config.maxCount && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Fail when Count Exceeds:</div>
																<div>{conf.config.maxCount}</div>
															</div>
														)}
														{conf.config.rollingMinutes && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Rolling Period:</div>
																<div>{conf.config.rollingMinutes} {conf.config.rollingMinutes == 1 ? "minute" : "minutes"}</div>
															</div>
														)}
														{conf.config.rollingHoursPeriod && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Rolling Period:</div>
																<div>{conf.config.rollingHoursPeriod} hours</div>
															</div>
														)}
														{conf.config.changePercentage && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Count when Changed:</div>
																<div>{conf.config.changePercentage * 100}%</div>
															</div>
														)}
														{conf.config.changeValue && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Count when Changed:</div>
																<div>{conf.config.changeValue}</div>
															</div>
														)}
														{conf.config.updateOutputEveryXSecs && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Min Time between Outputs:</div>
																<div>{secondsToTimePeriod.convert(conf.config.updateOutputEveryXSecs)}</div>
															</div>
														)}
														{conf.config.limitPercentage && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Deviation Percent:</div>
																<div>{conf.config.limitPercentage * 100}%</div>
															</div>
														)}
														{conf.config.limitVal && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Deviation Value:</div>
																<div>{conf.config.limitVal}</div>
															</div>
														)}
														{conf.config.offset1 && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Offset Value:</div>
																<div>{conf.config.offset1}</div>
															</div>
														)}
														{conf.config.pastTimeDays && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Previous Period:</div>
																<div>{conf.config.pastTimeDays} {conf.config.pastTimeDays == 1 ? "day" : "days"}</div>
															</div>
														)}
														{conf.config.numDaysCompare && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Days to Compare:</div>
																<div>{conf.config.numDaysCompare}</div>
															</div>
														)}
														{conf.config.percentDifference && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Difference Allowed:</div>
																<div>{conf.config.percentDifference * 100}%</div>
															</div>
														)}
														{conf.config.numWeeksToCheck && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Check Back:</div>
																<div>{conf.config.numWeeksToCheck} {conf.config.numWeeksToCheck == 1 ? "week" : "weeks"}</div>
															</div>
														)}
														{conf.config.comparisonPeriodHrs && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Comparison Period:</div>
																<div>{conf.config.comparisonPeriodHrs} {conf.config.comparisonPeriodHrs == 1 ? "hour" : "hours"}</div>
															</div>
														)}
														{conf.config.groupProcessVars && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Group Process Variables:</div>
																<div>{conf.config.groupProcessVars == true ? "Yes" : "No"}</div>
															</div>
														)}
														{conf.config.operator && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Var Comparitor:</div>
																<div>{conf.config.operator}</div>
															</div>
														)}
														{setPoint && (
															<div styleName="info-pre-title">
																<div styleName="info-pre-title-label">Set Point:</div>
																<div>{pointName.formatDescription(setPoint, true)}</div>
															</div>
														)}
													</div>
												)}
										</div>
										{processVariables && processVariables.length > 0 && (
											<div styleName="report-tooltip-title">
												Process Variables
											</div>
										)}
										{processVariables && processVariables.length > 0 && 
											processVariables.map((x,i) => {
												return (
													<div key={i} >
														{pointName.formatDescription(x, true)}
														{x && x.deselectPoint && (
															<span styleName="info-process-var-deselect">
																(when {pointName.formatDescription(x.deselectPoint, true)} = {x.deselectPoint.fetchWhenValue})
															</span>
														)}
													</div>
												);
											})}

										{/* Checks are used by Correlation Rules*/}
										{checks && checks.length > 0 && (
											<div styleName="report-tooltip-title">
												Checks
												{this.props.report.ruleInstance.reverseMode == true ? " - rule fails when " : " - rule passes when"}
											</div>
										)}
										{checks && checks.length > 0 && 
											checks.map((x,i) => {
												x.point = x.point || x.Point || { pointName: "" };
												return (
													<div key={i}>
														<span styleName="info-condition-operator">{i > 0 ? "AND " : ""}</span>
														{pointName.formatDescription(x.point, true)}{" "}
														<span styleName="info-condition-operator">{string.operator(x.operator) + " "}</span>
														{x.value}
													</div>
												);
											})}

										<div styleName="report-tooltip-title">
											{conf && conf.conditions.joiner == "AND"
														? "Pre Conditions (AND)"
														: "Pre Conditions (OR)"}
											
										</div>

										{cons && cons.length == 0 &&
										 dependantRules.length == 0 && (
											<div>There are no pre-conditions</div>
										 )}

										{cons && cons.length > 0 &&
											cons.map((x, i) => {
												x.point = x.point || x.Point || { pointName: "" };
												return (
													<div key={i}>
														{pointName.formatDescription(x.point, false)}{" "}
														<span styleName="info-condition-operator">{string.operator(x.operator) + " "}</span>
														{/* show min - max value or point name or min max point names */}
														{x.minValue !== null && x.maxValue !== null
															? x.minValue + " - " + x.maxValue
															: x.value !== null
																? x.value
																: x.val1Point !== null && x.val2Point !== null
																	? pointName.formatDescription(x.val1Point, true) +
																	  " - " +
																	  pointName.formatDescription(x.val2Point, true)
																	: pointName.formatDescription(x.val1Point, true)}
													</div>
												);
											})}

										{dependantRules.length > 0 &&
											dependantRules.map((x, i) => {
												return (
													<div key={i}>
														Rule {x.ruleInstanceTextId}
														{x.valueText && "is " + x.valueText}
														{x.checkLastXHours === 0 && " now"}
														{x.checkLastXHours !== 0 &&
															" in last " + x.checkLastXHours + " hours"}
														{x.diagnosticStepId && " and step ID is " + x.diagnosticStepId}
													</div>
												);
											})}

										<div style={{display:'flex',flexDirection:'column'}}>
											{
												this.props.report.ruleInstance &&
												this.props.report.ruleInstance.schedules &&
												this.props.report.ruleInstance.schedules.map(x => this.renderSchedule(x))}
										</div>
									</div>
								</div>
							</div>
						</CardContent>
					</Card>
				</Grid>

				{(this.props.report.null_report || this.props.report.components === null) && (
					<Grid
						item
						xs={12}
						styleName="report-component"
					>
						<Card styleName="report-card">
							<CardContent styleName="noreport">No report has been defined for this rule</CardContent>
						</Card>
					</Grid>
				)}

				<ChartCommentModals />

				{this.props.report.components.map((component, index) => {
					const chart = this.getComponent(component, index);
					if (chart) {
						return (
							<Grid
								item
								xs={12}
								key={component.type + component.ruleInstanceId.toString() + index.toString()}
								styleName="report-component"
							>
								<Card styleName="report-card">
									<CardContent>{chart}</CardContent>
								</Card>
							</Grid>
						);
					}
				})}

				{/* is diagnostic rule */}
				{this.props.report.ruleInstance.ruleId === 5 && (
					<Grid item xs={12} styleName="report-component">
						<Card styleName="report-card">
							<CardContent>
								<DiagnosticOutput
									report={this.props.report}
									ruleInstance={this.props.report.ruleInstance}
									timePeriod={this.props.time}
								/>
							</CardContent>
						</Card>
					</Grid>
				)}

				{this.props.report.ruleInstance &&
					this.props.report.ruleInstance.config &&
					this.props.report.ruleInstance.config.actions &&
					this.props.report.ruleInstance.config.actions.length > 0 && (
						<Grid item sm={12} md={6} styleName="report-component">
							<Card styleName="report-card">
								<CardContent>
									<div styleName="card-title">Actions</div>
									<div styleName="actions-wrap">
										{this.props.report.ruleInstance.config.actions.map((x, i) => {
											let message = "";

											switch (x.actionType) {
												case "Email":
													message = `Email: ${x.email_Phone_Point} (When rule status equals ${
														x.ruleStatus
													})`;
													break;
												case "SMS":
													message = `SMS: ${x.email_Phone_Point} (When rule status equals ${
														x.ruleStatus
													})`;
													break;
												case "Override":
												case "Auto":
												case "Set":
												case "Active":
												case "Inactive":
													message = `${x.actionType} point: ${
														x.email_Phone_Point
													} (When rule status equals ${x.ruleStatus})`;
													break;
												case "Trigger":
													return null;
												default:
													break;
											}

											return <div key={i}>{message}</div>;
										})}
									</div>
								</CardContent>
							</Card>
						</Grid>
					)}
				{this.props.report.ruleInstance &&
					this.props.report.ruleInstance.relatedRules &&
					this.props.report.ruleInstance.relatedRules.length > 0 && (
						<Grid item sm={12} md={6} styleName="report-component">
							<Card styleName="report-card">
								<CardContent>
									<div styleName="card-title">Related Rules</div>
									<div styleName="rrules-wrap">
										{this.props.report.ruleInstance.relatedRules.map((x, i) => {    
											let hasRun = x.endSiteLocal !== undefined && x.endSiteLocal !== null;
											if(!hasRun) {
												return null;
											}   
                                            const lastTimeRuleFailed = this.lastTimeRuleFailed(x);
                                            return (
                                                <Tooltip delay={50}>
                                                    <div
                                                        key={i}
                                                        styleName={"clickable" + (lastTimeRuleFailed.failedInTheLast4Hours ? " rrule-failed" : "")}
                                                        onClick={() => {
                                                            this.props.navigate("/Reports/" + x.ruleInstanceId, {
                                                                time: this.props.time
                                                            });
                                                            const scroll = document.getElementById("content-scroll");
                                                            scroll.scrollTop = 0;
                                                        }}
                                                    >
                                                        {x.name}
                                                    </div>
                                                    {lastTimeRuleFailed.failedInTheLast4Hours && (
                                                        <TooltipContent>
                                                            <div styleName="rrule-failed-tooltip">
                                                                Rule failed {lastTimeRuleFailed.failedHoursAgo}
                                                            </div>
                                                        </TooltipContent>
                                                    )}
                                                </Tooltip>
											);
										})}
									</div>
								</CardContent>
							</Card>
						</Grid>
					)}
				<ChartTooltip></ChartTooltip>
			</Grid>
		);
    }

	renderSchedule(schedule) {
		return (
			this.exists(schedule) &&
			(this.exists(schedule.endTime) ||
				this.exists(schedule.everyXSeconds) ||
				this.exists(
					schedule.minSecondsBetweenRuns
				) ||
				this.exists(schedule.runAtDay) ||
				this.exists(schedule.runAtDayOfMonth) ||
				this.exists(schedule.runAtDayOfWeek) ||
				this.exists(schedule.runAtTime) ||
				this.exists(
					schedule.runEveryNumMonths
				) ||
				this.exists(schedule.runEveryNumWeeks) ||
				(this.exists(
					schedule.runOnceDuringValidWindow
				) &&
					schedule.runOnceDuringValidWindow ===
						true) ||
				this.exists(schedule.startTime)) && (
				<div style={{ marginTop: 18 }}>
					<div styleName="report-tooltip-title">Schedule</div>
					{this.exists(schedule.startTime) &&
						this.exists(
							schedule.endTime
						) && (
							<div styleName="info-pre-title">
								<div styleName="info-div">
									<div style={{ paddingLeft: 10 }}>
										{HtmlParser(
											this.getScheduleTimes(
												schedule
													.startTime,
												schedule
													.endTime
											)
										)}
									</div>
								</div>
							</div>
						)}
					{this.exists(schedule.runAtTime) && (
						<div styleName="info-pre-title">
							<div styleName="info-div">
								<div style={{ paddingLeft: 10 }}>
									{schedule.runAtTime.map(
										run => {
											return <span>{run}{"  "}</span>;
										}
									)}
								</div>
							</div>
						</div>
					)}
					{this.exists(
						schedule.everyXSeconds
					) && (
						<div styleName="info-pre-title">
							Run every{" "}
							{schedule.everyXSeconds}{" "}
							seconds
						</div>
					)}
					{this.exists(
						schedule.minSecondsBetweenRuns
					) && (
						<div styleName="info-pre-title">
							Minimum time between runs:{" "}
							{
								schedule
									.minSecondsBetweenRuns
							} seconds
						</div>
					)}
					{this.exists(
						schedule.runAtDayOfMonth
					) && (
						<div styleName="info-pre-title">
							<div styleName="info-div">
								<div styleName="info-pre-title-label-nw">
									Run at day of month:
								</div>
								<div style={{ paddingLeft: 10 }}>
									{schedule.runAtDayOfMonth.map(
										run => {
											return <div>{run}</div>;
										}
									)}
								</div>
							</div>
						</div>
					)}
					{this.exists(schedule.runAtDay) && (
						<div styleName="info-pre-title">
							<div styleName="info-div">
								<div styleName="info-pre-title-label-nw">
									Run at day:
								</div>
								<div style={{ paddingLeft: 10 }}>
									{schedule.runAtDay.map(
										run => {
											return <div>{run}</div>;
										}
									)}
								</div>
							</div>
						</div>
					)}
					{this.exists(
						schedule.runAtDayOfWeek
					) && (
						<div styleName="info-pre-title">
							<div styleName="info-div">
								<div style={{ paddingLeft: 10 }}>
									{schedule.runAtDayOfWeek.map(
										run => {
											return <span>{run}{"  "}</span>;
										}
									)}
								</div>
							</div>
						</div>
					)}
					{this.exists(
						schedule.runAtDayOfMonth
					) && (
						<div styleName="info-pre-title">
							<div styleName="info-div">
								<div styleName="info-pre-title-label-nw">
									Run at day of month:
								</div>
								<div style={{ paddingLeft: 10 }}>
									{schedule.runAtDayOfMonth.map(
										run => {
											return <div>{run}</div>;
										}
									)}
								</div>
							</div>
						</div>
					)}
					{this.exists(
						schedule.runEveryNumWeeks
					) && (
						<div styleName="info-pre-title">
							Run Every{" "}
							{schedule.runEveryNumWeeks}{" "}
							week(s)
						</div>
					)}
					{this.exists(
						schedule.runEveryNumMonths
					) && (
						<div styleName="info-pre-title">
							Run Every{" "}
							{schedule.runEveryNumMonths}{" "}
							month(s)
						</div>
					)}
					{this.exists(
						schedule.runOnceDuringValidWindow
					) &&
						schedule
							.runOnceDuringValidWindow === true && (
							<div styleName="info-pre-title">
								Run once during Valid Window
							</div>
						)}
				</div>
			)
		)
	}
    
    lastTimeRuleFailed(rule) {
        const endSiteLocal = moment(rule.endSiteLocal)
            .subtract(moment().tz(this.props.currentSite.momentTimezone).utcOffset(), 'm');
        const diffToNow = moment().diff(endSiteLocal, 'h');
        return {
            failedInTheLast4Hours: diffToNow <= 4,
            failedHoursAgo: diffToNow <= 1 ? '1 hour ago' : diffToNow + ' hours ago'
        }
    }

	componentDidMount() {
		this.props.loadRuleInstance(this.props.match.params.ruleInstanceId);
	}

	childComponentLoaded(index){
		this.props.onComponentLoaded(index);
	}

	getComponent(component, index) {
		switch (component.type) {
			case "M - Percentage Outside Range Chart": {
				return <PercentageOutsideRangeChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "A - Validation Rule Chart": {
				return <ValidationRuleChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "L - Validation Rule Column Chart": {
				return <ValidationWithBarChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "B - Occurances Table": {
				return <OccurrencesTable component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "O - Distribution Samples Outside Range Chart": {
				return <HourlyFailureHeatMap component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "P - Distribution Samples With Time Offset Outside Range Chart": {
				return <DailyFailureHeatMap component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "N - Time Outside Range Chart": {
				return <TimeOutsideRangeChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "Q - Samples Outside Range Table": {
				return <SampleSummaryTable component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "C - History 365 Failed Hours Bar Chart": {
				return <DailyFailureChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "F - Line Chart (Rule Running Times Only)":
			case "F - Line Chart": {
				return <LineChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "Z - Live Line Chart": {
				return <div id="live-chart"><ReportLiveLineChart component={component} onLoadComplete={() => this.childComponentLoaded(index)} /></div>;
			}
			case "E - Learned Rule Table": {
				return (
					<LearnedRuleTable
						component={component}
						timePeriod={this.props.time}
						ruleInstance={this.props.selectedRuleInstance}
						onLoadComplete={() => this.childComponentLoaded(index)}
					/>
				);
			}
			case "H - Scatter Chart": {
				return <ScatterChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "J - Stacked Column Chart 100 Percent": {
				return <ColumnChart component={component} useStacking={true} usePercent={true} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "K - Column Chart": {
				return <ColumnChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "L - Stacked Column Chart": {
				return <ColumnChart component={component} useStacking={true} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "D - History Table": {
				return <HistoryTable component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "R - Validation Rule Outside Offset Chart": {
				return <ValidationRuleOutsideOffsetChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			case "S - Validation Rule Column Outside Offset Chart": {
				return <ValidationWithBarOutsideOffsetChart component={component} timePeriod={this.props.time} onLoadComplete={() => this.childComponentLoaded(index)} />;
			}
			default:
				// return <div>{component.type}</div>;
				return null;
		}
	}

	renderGraph() {
		return <div />;
	}

	shouldComponentUpdate(nextProps) {
		const props = this.props;
		for (var p in nextProps) {
			if (nextProps.hasOwnProperty(p)) {
				if (nextProps[p] !== props[p] && p != "match") {
					return true;
				}
			}
		}
		// pos MUI Select rerenders the component like 10 times without changing anything. laggy af
		return false;
    }
    getNextRunTime() {
        const date = moment(this.props.report.ruleInstance.nextRunTime);
        if (date.isValid())
            return date.format('DD/MM/YYYY hh:mm');
        return null;
    }
}

const bindAction = dispatch => {
	return {
		getReport: ruleInstanceId => dispatch(actions.getReport(1)),
		selectPeriod: event => dispatch(actions.selectPeriod(event.target.value)),
		loadRuleInstance: ruleInstanceId => dispatch(ruleinstanceactions.loadRuleInstance(ruleInstanceId)),
		toggleCalendar: () => dispatch(actions.toggleCalendar()),
		changeTime: time => dispatch(timeaction.updateTimeRange(time)),
		onComponentLoaded: (index) => dispatch(actions.onComponentLoaded(index)),
		toggleHeaderSelect: val => dispatch(headeractions.toggleHeaderSelect(val)),
        downloadPdf: (ruleInstanceId) => dispatch(actions.downloadPdf(ruleInstanceId)),
        resetState: () => dispatch(actions.resetState()),
		navigate: (uri, data) => dispatch(router.push(uri, data)),

		getCommentList: (ruleInstanceId, from, to) => dispatch(actions.getCommentList(ruleInstanceId, from, to)),
	};
};

const mapStateToProps = state => ({
	report: state.rulesreports.report,
	periods: state.rulesreports.periods,
	timePeriod: state.rulesreports.timePeriod,
	selectedRuleInstance: state.ruleinstancesearch.selectedRuleInstance,
	calendarOpen: state.rulesreports.calendarOpen,
      time: state.time.timeRange,
		currentSite: state.sitetree.currentSite,
	isMenuOpen: state.menu.isOpen,
	componentsLoaded: state.rulesreports.componentsLoaded,
	pdfDownloadInProgress: state.rulesreports.pdfDownloadInProgress,
});

export default connect(
	mapStateToProps,
	bindAction
)(Rules);



// WEBPACK FOOTER //
// ./src/ui/Rules/Reports/Reports.js